module.exports = (__webpack_require__("49fU"))(5);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/create-react-class/index.js from dll-reference vendor_library
// module id = DT0+
// module chunks = 24